import { render, staticRenderFns } from "./AudioBar.vue?vue&type=template&id=7bcb25c6&scoped=true&"
import script from "./AudioBar.vue?vue&type=script&lang=js&"
export * from "./AudioBar.vue?vue&type=script&lang=js&"
import style0 from "./AudioBar.vue?vue&type=style&index=0&id=7bcb25c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcb25c6",
  null
  
)

export default component.exports